(() => {
  const synchronizeFooterDetails = (root = document) => {
    const desktop = window.matchMedia('(min-width: 750px)').matches;
    root.querySelectorAll('[data-footer-details]').forEach((details) => {
      if (desktop) details.setAttribute('open', '');
      else details.removeAttribute('open');
    });
  };
  synchronizeFooterDetails();
  window.matchMedia('(min-width: 750px)').addEventListener('change', () => synchronizeFooterDetails());
  document.addEventListener('shopify:section:load', (event) => synchronizeFooterDetails(event.target));
})();
